import { render } from "./DesktopMenuBarTop.vue?vue&type=template&id=b5e84c5a&scoped=true"
import script from "./DesktopMenuBarTop.vue?vue&type=script&lang=js"
export * from "./DesktopMenuBarTop.vue?vue&type=script&lang=js"

import "./DesktopMenuBarTop.vue?vue&type=style&index=0&id=b5e84c5a&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b5e84c5a"]])

export default __exports__